import { render, staticRenderFns } from "./SearchYear.vue?vue&type=template&id=56e83706&"
import script from "./SearchYear.vue?vue&type=script&lang=js&"
export * from "./SearchYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports